module.exports = __webpack_public_path__ + "static/media/devices@2x.9ce282d1.png";